import { logger } from '@/utils/logging'
import { CreateShareLinkRequest, CreateShareLinkResponse, SharedContent } from './types'

const SHARE_API_HOST = 'https://share.angelstudios.io'

/**
 * @deprecated This function uses the now deprecated sharing service. If 1:1 sharing is used again, need to update usages to work with the new content sharing service.
 * @param data
 * @returns
 */
export const createShareLink = async (data: CreateShareLinkRequest): Promise<CreateShareLinkResponse | undefined> => {
  try {
    const response = await fetch(`${SHARE_API_HOST}/create`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      const errorText = await response.text()
      logger().error('Failed to create share link with no response.ok', errorText)
    }

    return response.json()
  } catch (error) {
    logger().error('Failed to create share link with unknown error', error)
    return undefined
  }
}

/**
 * @deprecated
 * @param guid
 * @returns
 */
export const getSharedContent = async (guid: string): Promise<SharedContent | undefined> => {
  try {
    const response = await fetch(`${SHARE_API_HOST}/shared/${guid}`, {
      headers: {
        'X-API-KEY': process.env.SHARE_API_KEY as string,
      },
    })

    if (!response.ok) {
      const errorText = await response.text()
      logger().error('Failed to get shared content', errorText)
    }

    return response.json()
  } catch (error) {
    logger().error('Failed to get shared content', error)
    return undefined
  }
}

/**
 * @deprecated
 * @param guid
 * @param id
 * @returns
 */
export const claimSharedContent = async (guid: string, id: string): Promise<SharedContent | undefined> => {
  try {
    const response = await fetch(`${SHARE_API_HOST}/claim/${id}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ recipient_uuid: guid }),
    })

    if (!response.ok) {
      const errorText = await response.text()
      logger().error('Failed to claim shared content', errorText)
    }

    return
  } catch (error) {
    logger().error('Failed to claim shared content', error)
    return undefined
  }
}

/**
 * @deprecated
 * @param url
 * @returns
 */
export const extractLastGuid = (url: string): string => {
  try {
    const urlObj = new URL(url)
    const pathSegments = urlObj.pathname.split('/')
    return pathSegments[pathSegments.length - 1] || ''
  } catch (error) {
    logger().error('Error extracting last guid from url', { url }, error as Error)
    return ''
  }
}
